export const legalDocumentsVersion = {
  privacyPolicyVersion: '3.0',
  termsPolicyVersion: '3.0',
};
